export const BLOG_CATEGORIES = [
  'all',
  'insights',
  'genetic_test',
  'rare_disease',
  'diagnostic',
  'interview',
  'product',
] as const;

export type BlogCategory = (typeof BLOG_CATEGORIES)[number];

/**
 * URL 파라미터·쿼리로 들어온 문자열이 아는 카테고리인지 검증한다.
 * 검색·카테고리 라우트가 같은 규칙을 써야 하므로 여기서 소유한다.
 */
export const isBlogCategory = (value: string): value is BlogCategory =>
  BLOG_CATEGORIES.includes(value as BlogCategory);

export const BLOG_CATEGORY_KEYS = ['0', '1', '2', '3', '4', '5', '6'] as const;

/**
 * 카테고리 값으로 `Blog.main.categories.{key}` 메시지 키를 찾는다.
 *
 * ⚠️ `String(indexOf(...))` 로 바꾸고 싶겠지만 안 된다 — next-intl 의 타입 안전 메시지 키가
 * `BLOG_CATEGORY_KEYS` 의 리터럴 유니온(`'0'|'1'|...`)에 의존해서, 반환 타입이 `string` 으로
 * 넓어지면 `t(\`categories.${key}.pageTitle\`)` 같은 호출이 빌드 타임에 깨진다.
 * `BLOG_CATEGORIES`·`BLOG_CATEGORY_KEYS` 를 나란히 유지해야 하는 건 이 헬퍼가 새로 만든
 * 결합이 아니라 레포 전역의 기존 관례다(`editors-pick.tsx`·`category-tabs-section.tsx` 도
 * 같은 인덱스 대응에 기댄다) — 이 헬퍼는 그 흩어진 대응 로직을 한곳으로만 모은다.
 */
export const getBlogCategoryKey = (category: BlogCategory) =>
  BLOG_CATEGORY_KEYS[BLOG_CATEGORIES.indexOf(category)];
